// The links format must follow the structure of our backend
export const extractMenu = (links) => {
  const menus = {}

  Object.keys(links).forEach(function (key) {
    Object.assign(menus, {
      [key]: links[key].href
    })
  })
  return menus
}

// Handle try catch errors. If messages from backend exist, return it. If not extract the catch error message
export const extractMessages = (err) => {
  let result = []
  if (err.response && err.response.data) {
    const { messages } = err.response.data
    if (messages && messages.length > 0) {
      messages.forEach(message => {
        result.push(message.message)
      })
    }
  } else if (err.message) {
    // try catch err message
    result.push(err.message)
  }
  return result
}

export const extractFieldMessages = (err) => {
  let result = []
  if (err.response && err.response.data) {
    const { fieldMessages } = err.response.data
    if (fieldMessages && fieldMessages.length > 0) {
      fieldMessages.forEach(message => {
        let pushMessage = message.field + ': '
        pushMessage += message.message.message
        result.push(pushMessage)
      })
    }
  }
  return result
}

export const extractFullMessages = (err) => {
  let result = extractMessages(err)
  result = result.concat(extractFieldMessages(err))
  return result
}

export const extractLabel = function (list, value) {
  if (list !== undefined && list !== null && value !== undefined && value !== null) {
    let label = ''
    for (var i = 0; i < list.length; i++) {
      const arr = list[i]
      if (arr.value === value) {
        label = arr.label
        break
      }
    }
    return label
  } else {
    return ''
  }
}

export const extractRecord = function (list, value) {
  if (list !== undefined && list !== null && value !== undefined && value !== null) {
    let result
    for (var i = 0; i < list.length; i++) {
      const arr = list[i]
      if (arr.value === value) {
        result = arr
        break
      }
    }
    return result
  } else {
    return null
  }
}
